<template>
<v-card>
  <v-list two-line class="py-0">
    <v-list-tile avatar @click="val=>$emit('click',item,val)">
      <v-list-tile-avatar>
        <v-icon size="32" :color="colorIcon">{{icon}}</v-icon>
      </v-list-tile-avatar>
      <v-list-tile-content>
        <v-list-tile-title :class="classTitle">{{item.title}}</v-list-tile-title>
        <v-list-tile-sub-title :class="classSubtitle">{{( userMacInfo[item.mac]||{}).hostname || item.mac }}</v-list-tile-sub-title>
      </v-list-tile-content>
    </v-list-tile>
  </v-list>
</v-card>
</template>

<script>
import UserAuth from '@/components/auth/UserAuth'

export default {
  name: 'MacroItem',
  mixins: [UserAuth],
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    icon() {
      return this.item.actived ? 'cast_connected' : 'cast';
    },
    colorIcon() {
      return this.item.enabled ? 'primary' : 'grey';
    },
    classTitle() {
      return this.item.enabled ? 'brown--text' : 'grey--text';
    },
    classSubtitle() {
      return this.item.enabled ? 'dark-grey--text' : 'grey--text';
    }
  }
}
</script>
Macro



// WEBPACK FOOTER //
// src/components/reactor/MacroItem.vue